import {
  useCallback, useEffect, useRef, useState
} from 'react';

export const useLessonLocalStorage = (lesson) => {
  const [lessonValues, setLessonValues] = useState({});
  const lessonKey = useRef('');

  useEffect(() => {
    lessonKey.current = `j2s_${lesson}`;
    const lessonValue = localStorage.getItem(lessonKey.current) || '{}';
    setLessonValues(JSON.parse(lessonValue));
  }, [lesson]);

  const getStorageValue = useCallback((key) => lessonValues[key] ?? '', [lessonValues]);

  const setStorageValue = useCallback((key, value) => {
    setLessonValues((prevState) => ({
      ...prevState,
      [key]: value
    }));
  }, []);

  const saveChanges = useCallback(() => {
    localStorage.setItem(lessonKey.current, JSON.stringify(lessonValues));
  }, [lessonValues]);

  return { getStorageValue, setStorageValue, saveChanges };
};
